<template>
  <div>
    <a-form-model class="form" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" ref="form">
      <a-tabs default-active-key="basicInfo">
        <a-tab-pane key="basicInfo" tab="基础信息">
          <a-row :gutter="[24, 16]" type="flex" align="bottom">
            <a-col class="w-1/2">
              <a-form-model-item label="负载类型ID" prop="loadedDeviceTypeId">
                <a-input v-model="form.loadedDeviceTypeId" />
              </a-form-model-item>
            </a-col>
            <a-col class="w-1/2">
              <a-form-model-item label="负载类型名称" prop="name">
                <a-input v-model="form.name" />
              </a-form-model-item>
            </a-col>
            <a-col class="w-full">
              <a-form-model-item label="负载类型类别" prop="categories">
                <a-select v-model="form.categories" mode="multiple">
                  <a-select-option v-for="category in $constRepository.loadedDevice.CATEGORY_OPTION"
                    :key="category.value" :value="category.value">
                    {{ category.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col class="w-full">
              <a-form-model-item label="设备详情页URL" prop="detailPage">
                <a-input v-model="form.detailPage" />
              </a-form-model-item>
            </a-col>
            <a-col class="w-full">
              <a-form-model-item label="属性" prop="propertyIds">
                <a-input
                  :value="`已选择${form.propertyIds.length}个(${form.properties.map((property) => property.identifier)})`"
                  @click="handlePropertySelect">
                  <a-tooltip slot="suffix" title="Extra information">
                    <a-icon type="arrow-right" style="color: rgba(0, 0, 0, 0.45)" />
                  </a-tooltip>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col class="w-full">
              <a-form-model-item label="发布区域" prop="regionIdentifiers">
                <a-input
                  :value="`已选择${form.regionIdentifiers.length}个（${form.regionIdentifiers.map((region) => region)}）`"
                  @click="handleRegionSelect">
                  <a-tooltip slot="suffix" title="Extra information">
                    <a-icon type="arrow-right" style="color: rgba(0, 0, 0, 0.45)" />
                  </a-tooltip>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col class="w-full">
              <a-form-model-item label="图片" prop="images">
                <a-card :tab-list="tabList" :active-tab-key="tabKey" @tabChange="(key) => (tabKey = key)">
                  <a-form :model="form.images[tabKey - 1]" layout="vertical">
                    <a-row :gutter="[24, 16]" type="flex" align="bottom">
                      <a-col class="w-full">
                        <a-form-model-item label="负载类型实体图" prop="solidImages">
                          <div class="clearfix">
                            <a-upload list-type="picture-card" accept="image/*" :customRequest="solidCustomRequest"
                              :data="form.images[tabKey - 1]" :file-list="form.images[tabKey - 1].solidImages"
                              @preview="handlePreview" :remove="removeSolidImages">
                              <div>
                                <a-icon type="plus" />
                                <div class="ant-upload-text">Upload</div>
                              </div>
                            </a-upload>
                            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                              <img alt="example" style="width: 100%;background-color: #e6e6e6;" :src="previewImage" />
                            </a-modal>
                          </div>
                        </a-form-model-item>
                      </a-col>
                      <a-col class="w-full">
                        <a-form-model-item label="负载类型线框图" prop="lineImages">
                          <div class="clearfix">
                            <a-upload list-type="picture-card" accept="image/*" :customRequest="lineCustomRequest"
                              :data="form.images[tabKey - 1]" :file-list="form.images[tabKey - 1].lineImages"
                              @preview="handlePreview" :remove="removeLineImages">
                              <div>
                                <a-icon type="plus" />
                                <div class="ant-upload-text">Upload</div>
                              </div>
                            </a-upload>
                            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                              <img alt="example" style="width: 100%;background-color: #e6e6e6;" :src="previewImage" />
                            </a-modal>
                          </div>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-form>
                </a-card>
              </a-form-model-item>
            </a-col>
            <a-col class="w-full">
              <a-form-model-item label="别名规则" prop="loadedDeviceTypeAliasRules">
                <a-table :data-source="form.loadedDeviceTypeAliasRules" :pagination="false"
                  :row-key="(record, index) => index">
                  <a-table-column key="aliasRule" title="别名类型" width="18%">
                    <template slot-scope="text, domain, index">
                      <a-form-model-item :prop="'loadedDeviceTypeAliasRules.' + index + '.aliasRule'" :rules="{
                        required: true,
                        message: '别名类型必填',
                        trigger: 'blur',
                      }">
                        <a-select allow-clear v-model="domain.aliasRule" show-search optionFilterProp="label"
                          :options="aliasRuleOptions" placeholder="请选择别名类型">
                        </a-select>
                      </a-form-model-item>
                    </template>
                  </a-table-column>
                  <a-table-column key="appType" title="应用类型" width="18%">
                    <template slot-scope="text, domain, index">
                      <a-form-model-item :prop="'loadedDeviceTypeAliasRules.' + index + '.appType'" :rules="{
                        required: true,
                        message: '应用类型必填',
                        trigger: 'blur',
                      }">
                        <a-select allow-clear v-model="domain.appType" show-search optionFilterProp="label"
                          :options="tabList" placeholder="请选择应用类型">
                        </a-select>
                      </a-form-model-item>
                    </template>
                  </a-table-column>
                  <a-table-column key="associateUniqueIdentifier" title="唯一标识" width="30%">
                    <template slot-scope="text, domain, index">
                      <a-form-model-item :prop="'loadedDeviceTypeAliasRules.' + index + '.associateUniqueIdentifier'"
                        :rules="{
                          required: (domain.aliasRule === 2 || domain.aliasRule === 3),
                          message: '唯一标识必填',
                          trigger: 'change',
                        }">
                        <a-input v-model.trim="domain.associateUniqueIdentifier" placeholder="请输入唯一标识"
                          style="width: 100%; " v-if="domain.aliasRule === 1" />
                        <a-input v-else v-model.trim="domain.associateUniqueIdentifier" placeholder="请选择唯一标识"
                          style="width: 100%; " @click="handleSelectRuleIdentifier(index, domain.aliasRule)">
                          <a-tooltip slot="suffix" title="选择标识" v-if="domain.aliasRule !== 1">
                            <a-icon type="arrow-right" style="color: rgba(0, 0, 0, 0.45)" />
                          </a-tooltip>
                        </a-input>
                      </a-form-model-item>
                    </template>
                  </a-table-column>
                  <a-table-column key="aliasName" title="别名" width="22%">
                    <template slot-scope="text, domain, index">
                      <a-form-model-item :prop="'loadedDeviceTypeAliasRules.' + index + '.aliasName'" :rules="{
                        required: true,
                        message: '别名必填',
                        trigger: 'blur',
                      }">
                        <a-input v-model="domain.aliasName" placeholder="请输入" style="width: 100%; " />
                      </a-form-model-item>
                    </template>
                  </a-table-column>
                  <a-table-column title="操作" key="action" width="12%" align="center">
                    <template slot-scope="text, domain, index">
                      <a-button type="link" size="small" style="margin-bottom: 24px;"
                        @click="removeDomain(index)">删除</a-button>
                    </template>
                  </a-table-column>
                </a-table>
                <a-form-model-item>
                  <a-button type="dashed" style="width: 100%" @click="addDomain">
                    <a-icon type="plus" /> 添加别名规则
                  </a-button>
                  <div>1、别名类型为"负载属性"时，唯一标识填写属性
                    <div>2、别名类型为"负载名称"时，唯一标识填写无效，系统会将负载ID作为唯一标识</div>
                  </div>
                </a-form-model-item>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="codeEdit" tab="代码编辑器" v-if="form.properties">
          <a-row :gutter="[24, 0]" type="flex" align="bottom" style="width: 96%;margin:1% auto">
            <a-col class="w-full">
              <a-form-model-item label="代码编辑器" prop="form">
                <vue-json-editor v-model="form.properties" :showBtns="false" :mode="'code'" lang="zh"
                  style="height: 700px" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
      <a-row :gutter="[24, 0]" type="flex" align="bottom" style="margin: 0 2% ">
        <a-col class="w-full">
          <a-form-item class="group-btn">
            <a-button type="primary" @click="onSubmit">确定</a-button>
            <a-button style="margin-left: 10px" @click="$router.back()">取消</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form-model>
    <loaded-device-properties-selector ref="loadedDevicePropertiesSelector" />
    <region-select-modal ref="regionSelectModal" />
    <upload-progress ref="uploadProgress" />
    <LoadedDeviceRulePropertiesSelector ref="loadedDeviceRulePropertiesSelector" />
  </div>
</template>

<script>
import vueJsonEditor from 'vue-json-editor';
import UploadProgress from '../../../components/upload-progress/UploadProgress';
import RegionSelectModal from '../region/components/RegionSelectModal';
import LoadedDevicePropertiesSelector from './components/LoadedDevicePropertiesSelector';
import LoadedDeviceRulePropertiesSelector from './components/LoadedDeviceRulePropertiesSelector';

export default {
  name: 'LoadedDeviceCreator',
  components: {
    RegionSelectModal,
    vueJsonEditor,
    UploadProgress,
    LoadedDevicePropertiesSelector,
    LoadedDeviceRulePropertiesSelector,
    // LoadedDevicePropertyCard,
  },
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      propertySelect: null,
      rules: {
        loadedDeviceTypeId: [{ required: true, message: '负载设备类型id 不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '负载设备类型名称 不能为空', trigger: 'blur' }],
      },
      progress: 1,
      form: {
        loadedDeviceTypeAliasRules: [],
        regionIdentifiers: [],
        propertyIds: [],
        properties: [],
        images: [
          {
            type: this.$constRepository.loadedDevice.ImageTypes.AIHOME,
            solidImages: [],
            lineImages: [],
          },
          {
            type: this.$constRepository.loadedDevice.ImageTypes.SMARTSPACE,
            solidImages: [],
            lineImages: [],
          },
          {
            type: this.$constRepository.loadedDevice.ImageTypes.NEXSMART,
            solidImages: [],
            lineImages: [],
          },
        ],
      },
      tabList: [
        {
          key: `${this.$constRepository.loadedDevice.ImageTypes.AIHOME}`,
          tab: this.$constRepository.loadedDevice.ImageTypeLabel[this.$constRepository.loadedDevice.ImageTypes.AIHOME],
          value: Number(this.$constRepository.loadedDevice.ImageTypes.AIHOME),
          label: this.$constRepository.loadedDevice.ImageTypeLabel[this.$constRepository.loadedDevice.ImageTypes.AIHOME],
        },
        {
          key: `${this.$constRepository.loadedDevice.ImageTypes.SMARTSPACE}`,
          tab: this.$constRepository.loadedDevice.ImageTypeLabel[
            this.$constRepository.loadedDevice.ImageTypes.SMARTSPACE
          ],
          value: Number(this.$constRepository.loadedDevice.ImageTypes.SMARTSPACE),
          label: this.$constRepository.loadedDevice.ImageTypeLabel[this.$constRepository.loadedDevice.ImageTypes.SMARTSPACE],
        },
        {
          key: `${this.$constRepository.loadedDevice.ImageTypes.NEXSMART}`,
          tab: this.$constRepository.loadedDevice.ImageTypeLabel[
            this.$constRepository.loadedDevice.ImageTypes.NEXSMART
          ],
          value: Number(this.$constRepository.loadedDevice.ImageTypes.NEXSMART),
          label: this.$constRepository.loadedDevice.ImageTypeLabel[this.$constRepository.loadedDevice.ImageTypes.NEXSMART],
        },
      ],
      aliasRuleOptions: Object.keys(this.$constRepository.loadedDevice.AliasRuleTypeTextObject).filter((i) => i !== '0').map((key) => ({
        value: Number(key),
        label: this.$constRepository.loadedDevice.AliasRuleTypeTextObject[key],
      })),
      tabKey: `${this.$constRepository.loadedDevice.ImageTypes.AIHOME}`,
    };
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async handlePreview(file) {
      const imageFile = file;
      if (!imageFile.url && !imageFile.preview) {
        imageFile.preview = await this.getBase64(imageFile.originFileObj);
      }
      this.previewImage = imageFile.url || imageFile.preview;
      this.previewVisible = true;
    },
    removeSolidImages(record) {
      // 找到是哪个卡片的图片需要删除
      const targetIndex = this.form.images.findIndex((image) => image.solidImages.find((simg) => simg.uid === record.uid));
      this.form.images[targetIndex].solidImages = this.form.images[targetIndex].solidImages.filter(
        (image) => image.uid !== record.uid,
      );
    },
    removeLineImages(record) {
      const targetIndex = this.form.images.findIndex((image) => image.lineImages.find((simg) => simg.uid === record.uid));
      this.form.images[targetIndex].lineImages = this.form.images[targetIndex].lineImages.filter(
        (image) => image.uid !== record.uid,
      );
    },
    async customRequest(request, module, submodule, imageFile) {
      this.$refs.uploadProgress.visible = true;
      const fileUploadResponse = await this.$apiManager.file.uploadFile(module, submodule, request.file);
      this.$refs.uploadProgress.visible = false;
      this.$store.commit('setUploadProgress', -1);
      if (fileUploadResponse.data.filePath) {
        const reader = new FileReader();
        reader.readAsDataURL(request.file);
        const params = {
          filePath: fileUploadResponse.data.filePath,
          uid: request.file.uid,
          status: 'done',
          name: request.file.name,
        };
        reader.onloadend = (e) => {
          const url = e.target.result;
          params.url = url;
          imageFile.push(params);
        };
      }
    },
    solidCustomRequest(request) {
      this.customRequest(
        request,
        this.$constRepository.file.Module.loadedDeviceType,
        this.$constRepository.file.Submodule.solidImages,
        request.data.solidImages,
      );
    },
    lineCustomRequest(request) {
      this.customRequest(
        request,
        this.$constRepository.file.Module.loadedDeviceType,
        this.$constRepository.file.Submodule.lineImages,
        request.data.lineImages,
      );
    },
    onSubmit() {
      // 校验有图片的情况下，项目是否未选择
      if (this.form.images.length > 0) {
        let flag = true;
        this.form.images.forEach((image) => {
          if (!image.type) {
            flag = false;
          }
        });
        if (!flag) {
          this.$message.warn('请选择图片所属项目');
          return;
        }
      }
      const images = this.form.images.map((image) => ({
        ...image,
        solidImages: image.solidImages.map((item) => item.filePath),
        lineImages: image.lineImages.map((item) => item.filePath),
      }));
      this.$refs.form.validate((relsValid) => {
        if (relsValid) {
          this.$apiManager.loadedDeviceType.createLoadedDeviceType({ ...this.form, images }).then(() => {
            this.$message.success('创建成功');
            this.$router.back();
          });
        } else {
          this.$message.warn('基础信息存在未填写的数据');
        }
      });
    },
    handlePropertySelect() {
      const toDO = (select, selectShow) => {
        this.form.propertyIds = select;
        this.form.properties = selectShow;
      };
      this.$refs.loadedDevicePropertiesSelector.selectType = 'checkbox';
      this.$refs.loadedDevicePropertiesSelector.loadedDeviceTypeId = this.form.loadedDeviceTypeId;
      this.$refs.loadedDevicePropertiesSelector.showCreateDialog(toDO);
    },
    handleSelectRuleIdentifier(index, aliasRule) {
      if (!aliasRule) {
        this.$message.warn('请先选择别名类型');
        return;
      }
      const toDO = (identifierItem) => {
        this.$set(this.form.loadedDeviceTypeAliasRules[index], 'associateUniqueIdentifier', identifierItem?.identifier);
        this.$set(this.form.loadedDeviceTypeAliasRules[index], 'aliasName', identifierItem?.name);
      };
      this.$refs.loadedDeviceRulePropertiesSelector.selectType = 'radio';
      this.$refs.loadedDeviceRulePropertiesSelector.isOption = aliasRule === 3;
      this.$refs.loadedDeviceRulePropertiesSelector.loadedDeviceTypeId = this.form.loadedDeviceTypeId;
      this.$refs.loadedDeviceRulePropertiesSelector.showCreateDialog(toDO);
    },
    handleRegionSelect() {
      const toDO = (select) => {
        this.form.regionIdentifiers = select;
      };
      this.$refs.regionSelectModal.showCreateDialog(toDO);
    },
    addDomain() {
      this.form.loadedDeviceTypeAliasRules.push({
        aliasRule: '',
        appType: '',
        associateUniqueIdentifier: '',
        aliasName: '',
      });
    },
    removeDomain(index) {
      this.form.loadedDeviceTypeAliasRules.splice(index, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.form {
  width: 100%;

  /deep/ .ant-form-item-label {
    width: 150px;
  }
}

/deep/.jsoneditor-poweredBy {
  display: none;
}

// /deep/.jsoneditor-outer {
//   height: 25vw;
// }
/deep/ .jsoneditor-vue {
  height: 100%;
}

.group-btn {
  margin-left: 16.7%;
}

.w-1\/3 {
  width: 33.33333333%;
}

.w-1\/2 {
  width: 50%;
}

.w-full {
  width: 100%;
}
</style>
